module.exports = __webpack_public_path__ + "static/media/logo-PCR-Long-title-CouleurHD.d843dc39.png";